import React, { memo } from "react";
import { ICellRendererParams } from "ag-grid-community";

import { TaskStatus } from "fond/types";

import { CellWrapper } from "./rowMenuRenderer.styles";
import { Chip } from "./StatusCellRenderer.styles";

type StatusEntry = {
  text: string;
  icon: JSX.Element;
} | null;

type States = TaskStatus["State"] | "CANCELLED";

interface IProps extends ICellRendererParams {
  state: States;
  stateEntries: { [key in States]: StatusEntry };
}

const StatusCellRenderer: React.FC<IProps> = memo(({ state, stateEntries }: IProps) => {
  if (!state) {
    return null;
  }
  const spec = stateEntries[state];
  if (!spec) {
    return null;
  }

  return (
    <CellWrapper>
      <Chip label={spec.text} icon={spec.icon} size="small" className={`status-${state}`} />
    </CellWrapper>
  );
});

StatusCellRenderer.displayName = "StatusCellRenderer";

export default StatusCellRenderer;
